import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { proposalsUrl } from "../requests/getProposals";
import postProposalSubmission from "../requests/postProposalSubmission";
export default function usePostOpportunity(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (request) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postProposalSubmission(request, config);
        },
        onSuccess: () => {
            // NOTE: invalidate all cached paginated opportunities queries
            queryClient.invalidateQueries({ queryKey: [proposalsUrl()] });
        },
        cacheTime: 0,
    });
    return mutation;
}
//# sourceMappingURL=usePostProposalSubmission.js.map